module.exports = "/_next/static/images/slide4-2x-bf3caf7afbc6f7e7a9e59d1fa4bd08b4.jpg.webp";